document.addEventListener('keydown', function( event ) {
    if ( Module && Module.CasinoUtilsExecuteLua ) {
        Module.CasinoUtilsExecuteLua( "if inputListener then inputListener:Dispatch('" + event.key + "') end" );
    }
}, false);



//////////////////
// WEBPACK FOOTER
// /src/src/platform/emscripten/Application.callbacks.js
// module id = 22
// module chunks = 0